import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import ivclass from '../../Modules/IVClass';
import { PlatformType } from '../../constants/common';
import Image from '../common/Image';
const Feature = (props) => {
    const { highlightedText, plainText, featuresCheckImage, platform, theme = 'light', } = props;
    const sizeOnDevice = {
        [PlatformType.Desktop]: {
            width: 12,
            height: 10,
        },
        [PlatformType.Tablet]: {
            width: 13,
            height: 10,
        },
        [PlatformType.Mobile]: {
            width: 11,
            height: 8,
        },
    };
    const size = sizeOnDevice[platform];
    return (_jsx("div", { className: ivclass('iv-pb-20'), children: _jsxs("div", { className: ivclass('iv-flex iv-items-center'), children: [_jsx("span", { className: ivclass('iv-pr-9 lg:iv-pr-[11px]'), children: _jsx(Image, { src: featuresCheckImage, alt: "check mark", loading: "lazy", width: size.width, height: size.height }) }), _jsxs("div", { className: ivclass({ 'iv-text-white-50': theme === 'dark' }, 'xl:iv-text-body-2xl iv-text-body-xl sm:iv-text-body-l', 'xl:iv-m-body-2xl iv-m-body-xl sm:iv-m-body-l', 'iv-font-medium'), children: [_jsx("span", { className: ivclass({ 'iv-text-grey-0': theme === 'dark' }), children: highlightedText }), plainText] })] }) }));
};
export default Feature;
